import { computed, defineComponent, PropType } from "vue";
import { OfferJson } from "../OrderForm";
import SmeOfferBox, { SmeOfferBoxType } from "./SmeOfferBox";
import { SmeOrderJson } from "../utils/SmeUtils";
import Utils from "../utils/Utils";

const SmeOffersTabs = defineComponent({
    template: `
        <div class="SmeOffers__tabs">
            <template v-for="month in sortedmonths">
                <button
                    class="SmeOffers__tab"
                    :class="{ 'SmeOffers__tab--selected': selected == month, 'SmeOffers__tab--highlighted': highlighted.includes(month) }"

                    @click="$emit('select', month)"
                >
                    <b>{{ month / 12 }}</b>

                    {{ yearsTitle(month) }}
                </button>
            </template>
        </div>
    `,

    emits: [
        'select',
    ],

    props: {
        months: { type: Array as PropType<number[]>, required: true },
        selected: { type: Number },
        highlighted: { type: Array as PropType<number[]>, default: [] },
    },

    setup(props, ctx) {
        const sortedmonths = computed(() => {
            let list = props.months.sort((a, b) => {
                return a - b;
            });

            return list;
        });

        function yearsTitle(months: number) {
            return Utils.yearsTitlePostfix(months);
        }

        return {
            sortedmonths,

            yearsTitle,
        };
    },
});

export default defineComponent({
    components: {
        SmeOfferBox,
        SmeOffersTabs,
    },

    template: `
        <div class="SmeOffers">
            <SmeOffersTabs
                :months="months"
                :highlighted="highlighted"
                :selected="options.offer?.price_warranty"

                @select="onSelectTab"
            />

            <template v-for="offer in filteredoffers">
                <SmeOfferBox
                    v-if="offer.price_warranty == selected"

                    :options="options"
                    :offer="options.code ? options.offer : offer"

                    :type="type"

                    :label_code_notice="'Uwaga: aby skorzystać z promocji wybierz ofertę na ' + codenoticemonths + '.'"

                    @select="$emit('select', options.code ? options.offer : offer)"
                    @code:loading="$emit('code:loading')"
                    @code:change="$emit('code:change')"
                >
                    <slot></slot>
                </SmeOfferBox>
            </template>
        </div>
    `,

    emits: [
        'select:tab',
        'select',
        'code:loading',
        'code:change',
    ],

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
        offers: { type: Array as PropType<OfferJson[]>, required: true },
        selected: { type: Number },

        type: { type: String as PropType<SmeOfferBoxType>, default: 'standard' },
    },

    setup(props, ctx) {
        const filteredoffers = computed(() => {
            let list = props.offers.filter(v => v.tariff == props.options.tariff);

            list = list.sort((a, b) => {
                return (b.hidden ? 1 : 0) - (a.hidden ? 1 : 0);
            });

            let found = [];
            const result = [];

            for (const offer of list) {
                if (!found.includes(offer.price_warranty)) {
                    result.push(offer);
                    found.push(offer.price_warranty);
                }
            }

            return result;
        });

        const months = computed(() => {
            let result = filteredoffers.value.map(v => v.price_warranty);

            result.sort();

            const r = [];

            for (const m of result) {
                if (!r.includes(m)) {
                    r.push(m);
                }
            }

            return r;
        });

        const highlighted = computed(() => {
            const result = [];

            for (const offer of filteredoffers.value) {
                if (offer.hidden) {
                    result.push(offer.price_warranty);
                }
            }

            if (result.length == months.value.length) {
                return [];
            }

            return result;
        });

        const codenoticemonths = computed(() => {
            const result = [];

            for (const m of highlighted.value) {
                result.push(m / 12);
            }

            if (result.length) {
                const last = result.pop();
                result.push(Utils.yearsTitle(last * 12));
            }

            return result.join(', ');
        });

        function onSelectTab(months: number) {
            ctx.emit('select:tab', months);
        }

        return {
            filteredoffers,
            months,
            highlighted,
            codenoticemonths,

            onSelectTab,
        };
    },
});
